var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-navbar', {
    ref: "abc",
    staticClass: "d-lg-none",
    attrs: {
      "toggleable": "",
      "sticky": ""
    }
  }, [_c('b-navbar-brand', {
    staticClass: "text-light",
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('versionModal');
      }
    }
  }, [_c('span', [_vm._v("OmniStock OMS")]), _vm.$store.state.config.general.environment !== 'production' ? _c('small', {
    staticClass: "text-warning pl-2"
  }, [_vm._v(_vm._s(_vm.$store.state.config.general.environment))]) : _vm._e()]), _c('b-button', {
    staticClass: "search-modal-open-button px-2",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('headerSearchModal');
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-light",
    attrs: {
      "icon": "search"
    }
  })], 1), _c('b-navbar-toggle', {
    attrs: {
      "target": "navbar-toggle-collapse"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-light",
    attrs: {
      "icon": "bars"
    }
  })], 1), _c('b-collapse', {
    staticClass: "bg-midnight-bloom",
    attrs: {
      "id": "navbar-toggle-collapse",
      "is-nav": ""
    }
  }, [_c('menu-vue')], 1), _c('b-modal', {
    attrs: {
      "id": "versionModal",
      "hide-footer": "",
      "title": "OMS Versie"
    }
  }, [_vm._v(_vm._s(_vm.appVersion))]), _c('b-modal', {
    attrs: {
      "id": "headerSearchModal",
      "hide-footer": "",
      "title": "Zoeken",
      "centered": ""
    },
    on: {
      "shown": function ($event) {
        return _vm.$refs['headerSearchComponent'].focus();
      }
    }
  }, [_c('header-search', {
    ref: "headerSearchComponent",
    attrs: {
      "history-in-overlay": false
    },
    on: {
      "success": function ($event) {
        return _vm.$bvModal.hide('headerSearchModal');
      }
    }
  })], 1)], 1), _c('div', {
    staticClass: "app-header header-shadow header-text-light d-none d-lg-flex"
  }, [_c('div', {
    staticClass: "app-header__logo"
  }, [_c('div', {
    staticClass: "text-center mx-auto font-size-xlg"
  }, [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "/",
      "id": "versionPopover"
    }
  }, [_vm._v("OmniStock OMS")]), _vm.$store.state.config.general.environment !== 'production' ? _c('small', {
    staticClass: "text-warning pl-2"
  }, [_vm._v(_vm._s(_vm.$store.state.config.general.environment))]) : _vm._e(), _c('b-popover', {
    attrs: {
      "target": "versionPopover",
      "placement": "bottom",
      "triggers": "hover",
      "delay": "1500",
      "content": `versie: ${_vm.appVersion}`
    }
  })], 1)]), _c('div', {
    staticClass: "app-header__mobile-menu"
  }), _vm._m(0), _c('div', {
    staticClass: "app-header__content"
  }, [_c('div', {
    staticClass: "app-header-left"
  }, [_c('header-search')], 1), _c('div', {
    staticClass: "app-header-right text-white"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.signed-in-as')) + ": "), _c('b-dropdown', {
    staticClass: "m-1",
    attrs: {
      "right": "",
      "toggle-class": "btn-sm"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.user.name))])]), _c('b-dropdown-text', [_c('a', {
    attrs: {
      "href": _vm.$store.state.omniPortalBaseURL
    }
  }, [_vm._v("OmniPortal")])])], 2)], 1)])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app-header__menu"
  }, [_c('span', [_c('button', {
    staticClass: "btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "btn-icon-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v fa-w-6"
  })])])])]);

}]

export { render, staticRenderFns }